export type Tab = "deposit" | "withdraw" | "notes" | "ve" | "gov" | "am" | "relayers";

const TABS: { id: Tab; label: string; idx: string }[] = [
  { id: "deposit", label: "Deposit", idx: "01" },
  { id: "withdraw", label: "Withdraw", idx: "02" },
  { id: "notes", label: "My notes", idx: "03" },
  { id: "ve", label: "veTONADO", idx: "04" },
  { id: "gov", label: "Governance", idx: "05" },
  { id: "am", label: "AM claim", idx: "06" },
  { id: "relayers", label: "Relayers", idx: "07" },
];

export function TabSwitch({ value, onChange }: { value: Tab; onChange: (t: Tab) => void }) {
  return (
    <div className="tabs" role="tablist" aria-label="Pool operations">
      {TABS.map((t) => (
        <button
          key={t.id}
          role="tab"
          type="button"
          aria-selected={value === t.id}
          className={`tabs__item ${value === t.id ? "tabs__item--active" : ""}`}
          onClick={() => onChange(t.id)}
        >
          <span className="tabs__idx">{t.idx}</span>
          <span className="tabs__label">{t.label}</span>
        </button>
      ))}
    </div>
  );
}
